import { getQueryObjectFromObject as f } from "@partoohub/utils";
import { ApiResourceBaseClass as p } from "./baseApiCalls.js";
const i = "google-oauth-accounts", g = "facebook-oauth-accounts", u = {
  GOOGLE_MY_BUSINESS: i,
  gmb: i,
  FACEBOOK: g,
  facebook: g
};
class _ extends p {
  /**
   * Retrieves location details for a given Google account.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/{partner}/locations/{locationId}`
   *
   * @param {string} locationId - The ID of the location
   * @param {AccountPartnerResourceName | AccountPartner} partner - The partner type (e.g., GOOGLE_MY_BUSINESS)
   * @returns {Promise<V2LocationData>} A promise that resolves to the location data
   */
  getLocationDetail = async (t, a) => {
    const { data: o } = await this.get(
      `${u[a]}/locations/${t}`,
      { partoo_ui: "True" }
    );
    return o;
  };
  /**
   * Searches for partner accounts using fuzzy search and pagination.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/account/search`
   */
  searchAccount = async (t, a, o = !1, e = 1, c) => {
    const { data: s } = await this.get("account/search", {
      partner: t,
      fuzzy_query: a,
      all_accounts: o,
      page: e,
      gmb_account_status: c
    });
    return s;
  };
  /**
   * Searches for GMB accounts.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/google-oauth-accounts/{accountId}/accounts`
   */
  searchGmbAccounts = async (t, a, o, e = !1, c = 1) => {
    const { data: s } = await this.get(
      `${i}/${t}/accounts`,
      {
        fuzzy_query: a,
        is_active: o,
        all_accounts: e,
        page: c
      }
    );
    return s;
  };
  /**
   * Retrieves detailed information of specific PublisherOAuthAccount (Google or Facebook).
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/{partner}/{accountId}/information`
   */
  getAccountDetails = async (t, a) => {
    const { data: o } = await this.get(
      `${u[a]}/${t}/information`
    );
    return o;
  };
  /**
   * Fuzzy search on locations for a given partner.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/{partner}/locations/search`
   */
  fuzzySearchLocations = async (t, a, o, e, c, s, n, r) => {
    const l = f({
      query: a.trim(),
      page: o,
      oauth_account_id: e,
      google_account_id: c,
      not_connected_only: n,
      verification_status: r,
      google_location_id__in: s,
      partoo_ui: !0
    }), { data: h } = await this.get(
      `${u[t]}/locations/search`,
      l
    );
    return h;
  };
  /**
   * Performs fuzzy search on Google locations for verifications.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/verifications/fuzzy-google-locations`
   */
  verificationsFuzzySearchLocations = async (t) => {
    const { data: a } = await this.get(
      "verifications/fuzzy-google-locations",
      t
    );
    return a;
  };
  /**
   * Retrieves available verification options for a given Google location.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/verifications/google-locations/{googleLocationId}/options`
   */
  fetchGoogleVerificationsOptions = async (t) => {
    const { data: a } = await this.get(
      `verifications/google-locations/${t}/options`
    );
    return a;
  };
  /**
   * Starts a Google verification process for a location.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/verifications/google-locations/{googleLocationId}/start`
   */
  startGoogleVerification = async (t, a) => {
    const { method: o, phone_number: e, email: c, full_name: s } = a, n = { method: o };
    ["SMS", "PHONE_CALL"].includes(o) && e ? n.phone_number = e : o === "EMAIL" && c ? n.email = c : o === "ADDRESS" && s && (n.full_name = s);
    const { data: r } = await this.post(
      `verifications/google-locations/${t}/start`,
      n
    );
    return r;
  };
  /**
   * Completes a Google verification by submitting the pin code.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/verifications/google-locations/{googleLocationId}/complete`
   */
  completeGoogleVerification = async (t, a) => {
    const { data: o } = await this.post(
      `verifications/google-locations/${t}/complete`,
      a
    );
    return o;
  };
  /**
   * Triggers a refresh of Facebook accounts.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/facebook-oauth-accounts/{accountId}/refresh[?fetch_origin=...]`
   */
  refreshFacebookAccounts = async (t, a) => {
    const o = `${g}/${t}/refresh${a ? `?fetch_origin=${a}` : ""}`, { data: e } = await this.post(o);
    return e;
  };
  /**
   * Retrieves the missing scopes of a Facebook Oauth Account that need to be refreshed.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/facebook-oauth-account/to-reauthenticate`
   */
  getFacebookOauthAccountToReauthenticate = async () => {
    const { data: t } = await this.get(
      "facebook-oauth-account/to-reauthenticate"
    );
    return t;
  };
  /**
   * Triggers a refresh of GMB accounts.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/google-oauth-accounts/{accountId}/refresh`
   */
  refreshGMBAccounts = async (t) => {
    const { data: a } = await this.post(
      `${i}/${t}/refresh`
    );
    return a;
  };
  /**
   * Delete Google PublisherOauthAccount by user .
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/api/v2/account/{accountId}`
   */
  disconnect = async (t) => {
    const { data: a } = await this.delete(`account/${t}`);
    return a;
  };
  /**
   * Searches for Google locations.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/google-locations/search`
   */
  googleLocationsSearch = async (t, a, o, e) => {
    const { data: c } = await this.get("google-locations/search", {
      query: t,
      partoo_page_size: a,
      google_page_size: o,
      region_code: e
    });
    return c;
  };
}
export {
  _ as Account,
  u as partnerToResourceUri
};
